import {
    ExternalHyperlink,
    AlignmentType,
    Document,
    HeadingLevel,
    Paragraph,
    TabStopPosition,
    TabStopType,
    TextRun,
    UnderlineType,
    TableOfContents,
    Header,
    PageNumber,
    ImageRun,
    Footer,
    NumberFormat,
    InternalHyperlink,
    Bookmark,
    TextWrappingType,
    TextWrappingSide,
    ShadingType,
    BorderStyle,
    PageReference,
    HorizontalPositionRelativeFrom,
    VerticalPositionRelativeFrom,
    LevelFormat,
    convertInchesToTwip,
    Table,
    TableRow,
    TableCell,
    WidthType,
} from 'docx';

const SUMMARYNOTAVAILABLE = 'Summary is not available';

export class DocumentCreator {
    // tslint:disable-next-line: typedef
    noneBorders: any = {
        top: {
            style: BorderStyle.NONE,
            size: 0,
            color: 'FFFFFF',
            outlineLevel: 0,
        },
        bottom: {
            style: BorderStyle.NONE,
            size: 0,
            color: 'FFFFFF',
            outlineLevel: 0,
        },
        left: {
            style: BorderStyle.NONE,
            size: 0,
            color: 'FFFFFF',
            outlineLevel: 0,
        },
        right: {
            style: BorderStyle.NONE,
            size: 0,
            color: 'FFFFFF',
            outlineLevel: 0,
        },
    };

    bottomBorders: any = {
        bottom: {
            style: BorderStyle.THREE_D_EMBOSS,
            size: 1,
            color: '808080',
            outlineLevel: 0,
        },
    };

    numbering: any = {
        config: [
            {
                reference: 'my-unique-bullet-points',
                levels: [
                    {
                        level: 0,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(0.2), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 1,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(0.4), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 2,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(0.6), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 3,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(0.8), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 4,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(1), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 5,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(1.2), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 6,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(1.4), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 7,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(1.6), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    {
                        level: 8,
                        // format: LevelFormat.BULLET,
                        // text: '\u2022',
                        alignment: AlignmentType.LEFT,
                        style: {
                            paragraph: {
                                indent: { left: convertInchesToTwip(1.8), hanging: convertInchesToTwip(0.1) },
                                spacing: { after: 70 },
                            },
                        },
                    },
                    // {
                    //     level: 9,
                    //     // format: LevelFormat.BULLET,
                    //     // text: '\u2022',
                    //     alignment: AlignmentType.LEFT,
                    //     style: {
                    //         paragraph: {
                    //             indent: { left: convertInchesToTwip(2), hanging: convertInchesToTwip(0.1) },
                    //             spacing: { after: 70 },
                    //         },
                    //     },
                    // },
                ],
            },
        ],
    };

    public create([gyanSummary, allTopicArticles, topicLevelMultidocSummary]: any): Document {
        const styles = this.loadStyles();
        const { headers, footers } = this.loadHeaderFooter();

        let topicListBulleted: any = [];
        gyanSummary.topics.map((topic: any) => {
            topicListBulleted = this.topicSummary(topic, 0, topicListBulleted, false);
        });

        let topicListBulletedWithArticleCount: any = [];
        gyanSummary.topics.map((topic: any) => {
            topicListBulletedWithArticleCount = this.topicSummary(topic, 0, topicListBulletedWithArticleCount, true);
        });

        let pages: any = [];
        pages = this.firstPage(gyanSummary, pages);
        // pages = this.secondPage(pages);
        pages = this.tableOfContents(gyanSummary, pages);
        // pages = this.researchBriefPage(gyanSummary, pages);
        const topicPages = this.topicCard(gyanSummary.rootTopic, allTopicArticles, topicLevelMultidocSummary, [], 0, {}, 'article', 'main');
        pages = pages.concat(topicPages);

        const additionalTopicPages = this.topicCard(gyanSummary.rootTopic, allTopicArticles, topicLevelMultidocSummary, [], 0, {}, 'article', 'additional');

        if (additionalTopicPages.length > 0) {
            pages.push(
                new Paragraph({
                    text: 'Additional Articles',
                    alignment: AlignmentType.LEFT,
                    style: 'addheadingMain',
                    pageBreakBefore: true,
                    spacing: {
                        after: 600,
                    },
                }),
            );
        }

        pages = pages.concat(additionalTopicPages);

        return new Document({
            numbering: this.numbering,
            styles: styles,
            features: {
                updateFields: true,
            },
            compatibility: {
                version: 15,
                doNotExpandShiftReturn: true,
                spaceForUnderline: true,
                noExtraLineSpacing: false,
                suppressTopSpacing: false,
            },
            sections: [
                {
                    properties: {
                        page: {
                            pageNumbers: {
                                start: 1,
                                formatType: NumberFormat.DECIMAL,
                            },
                        },
                    },
                    headers,
                    footers,
                    children: pages,
                },
            ],
        });
    }

    public loadHeaderFooter() {
        // @ts-expect-error: Suppressing this specific error
        const gyanLogo = new ImageRun({
            data: 'data:image/png;base64,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',
            transformation: {
                width: 97,
                height: 33,
            },
        });

        const headers = {
            default: new Header({
                children: [
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        children: [gyanLogo],
                        // border: this.bottomBorders,
                        outlineLevel: 0,
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        children: [],
                        border: this.bottomBorders,
                        outlineLevel: 0,
                    }),
                    new Paragraph({
                        alignment: AlignmentType.LEFT,
                        children: [],
                        border: this.noneBorders,
                        outlineLevel: 0,
                    }),
                ],
            }),
        };

        const footers = {
            default: new Footer({
                children: [
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        borders: this.noneBorders,
                        rows: [
                            new TableRow({
                                children: [
                                    new TableCell({
                                        width: { size: 50, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                alignment: AlignmentType.LEFT,
                                                children: [new TextRun('© GyanAI, Inc.  All rights reserved.')],
                                                style: 'pagefoortext1',
                                            }),
                                        ],
                                    }),
                                    new TableCell({
                                        width: { size: 50, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                alignment: AlignmentType.RIGHT,
                                                children: [
                                                    new TextRun({
                                                        children: [PageNumber.CURRENT],
                                                    }),
                                                ],
                                                style: 'pagefoortextpageno1',
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        };

        return { headers, footers };
    }

    public loadStyles() {
        //const font = 'Work Sans, sans-serif';
        const font = 'Tahoma';
        const fontSizeMultiply = 1.2;
        return {
            default: {
                heading1: {
                    run: {
                        size: 0,
                        color: '#FFFFFF',
                    },
                },
                heading2: {
                    run: {
                        size: 0,
                        color: '#FFFFFF',
                    },
                },
                heading3: {
                    run: {
                        size: 0,
                        color: '#FFFFFF',
                    },
                },
                heading4: {
                    run: {
                        size: 0,
                        color: '#FFFFFF',
                    },
                },
                heading5: {
                    run: {
                        size: 0,
                        color: '#FFFFFF',
                    },
                },
            },
            paragraphStyles: [
                {
                    id: 'headingMain',
                    name: 'Heading Main',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 28,
                        color: '#000000',
                        allCaps: false,
                        bold: false,
                    },
                    paragraph: {
                        spacing: {
                            // line: 800,
                            // before: 250,
                            // after: 100,
                        },
                        indent: {
                            left: 100,
                            right: 100,
                        },
                    },
                },
                {
                    id: 'addheadingMain',
                    name: 'Add Heading Main',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 28,
                        color: '#000000',
                        allCaps: false,
                        bold: false,
                        marginBottom: 100,
                    },
                    paragraph: {
                        spacing: {
                            after: 600,
                        },
                    },
                },
                {
                    id: 'topicHeadingcp',
                    name: 'Topic Heading Copy without heading',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 28,
                        color: '#000000',
                        italics: false,
                        allCaps: false,
                        bold: false,
                        //characterSpacing: 10,
                    },
                    paragraph: {
                        spacing: {
                            before: 50,
                            after: 120,
                        },
                    },
                },
                {
                    id: 'topicHeading',
                    name: 'Topic Heading',
                    quickFormat: false,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 20 * fontSizeMultiply,
                        color: '#000000',
                        italics: false,
                        allCaps: false,
                        bold: true,
                        //characterSpacing: 15,
                    },
                    paragraph: {
                        spacing: {
                            before: 50,
                            after: 120,
                        },
                    },
                },
                {
                    id: 'topicHeadingHidden',
                    name: 'Topic Heading Hidden',
                    quickFormat: false,
                    run: {
                        size: 1,
                    },
                },
                {
                    id: 'aboutHeading2',
                    name: 'About Heading 2',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        // fontFamily: 'FreeSans',
                        size: 20 * fontSizeMultiply,
                        color: '#444444',
                        allCaps: true,
                        bold: true,
                        characterSpacing: 25,
                    },
                    paragraph: {
                        spacing: {
                            before: 240,
                            after: 120,
                        },
                        indent: {
                            left: 400,
                        },
                    },
                },
                {
                    id: 'tocLinks',
                    name: 'tocLinks',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 22 * fontSizeMultiply,
                        color: '#666666',
                        characterSpacing: 10,
                    },
                    paragraph: {
                        spacing: {
                            before: 100,
                            after: 400,
                        },
                    },
                },
                {
                    id: 'aboutPointPara',
                    name: 'aboutPointPara',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        // fontFamily: 'FreeSans',
                        size: 13 * fontSizeMultiply,
                        color: '#333333',
                        italics: true,
                    },
                    paragraph: {
                        indent: {
                            left: 400,
                        },
                    },
                },
                {
                    id: 'topicText1',
                    name: 'Topic Text 1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        // fontFamily: 'FreeSans',
                        size: 20 * fontSizeMultiply,
                        color: '#333333',
                        italics: true,
                        allCaps: true,
                        bold: true,
                        characterSpacing: 2,
                    },
                    paragraph: {
                        spacing: {
                            before: 240,
                            after: 120,
                        },
                    },
                },
                {
                    id: 'gyanReportSubheading',
                    name: 'gyanReportSubheading',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        color: '666666',
                        font: font,
                        fontFamily: font,
                        characterSpacing: 10,
                        backgroundColor: 'CCCCCC',
                        bold: true,
                        size: 20 * fontSizeMultiply,
                    },
                    paragraph: {
                        indent: {
                            left: 400,
                            right: 400,
                        },
                    },
                },
                {
                    id: 'paragraphWithBG1',
                    name: 'paragraphWithBG1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        color: '333333',
                        font: font,
                        fontFamily: font,
                        size: 14 * fontSizeMultiply,
                        characterSpacing: 2,
                        italics: true,
                    },
                    paragraph: {
                        // line: 400,
                        padding: 10,
                    },
                },
                {
                    id: 'paragraphGray1',
                    name: 'paragraph Gray 1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 16 * fontSizeMultiply,
                        color: '#666666',
                        italics: false,
                        characterSpacing: 2,
                    },
                },
                {
                    id: 'paragraph1',
                    name: 'paragraph 1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 18.5 * fontSizeMultiply,
                        color: '#333333',
                        italics: false,
                        characterSpacing: 2,
                    },
                },
                {
                    id: 'paragraphIndented1',
                    name: 'paragraph indented 1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 15 * fontSizeMultiply,
                        color: '#333333',
                        italics: false,
                        characterSpacing: 2,
                    },
                    paragraph: {
                        spacing: {
                            after: 10,
                        },
                    },
                },
                {
                    id: 'textBold1',
                    name: 'Text Bold 1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 13 * fontSizeMultiply,
                        color: '#666666',
                        bold: true,
                    },
                },
                {
                    id: 'pagefoortext1',
                    name: 'pagefoortext1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 13 * fontSizeMultiply,
                        color: '#000000',
                    },
                },
                {
                    id: 'pagefoortextpageno1',
                    name: 'pagefoortextpageno1',
                    basedOn: 'Normal',
                    quickFormat: true,
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 13 * fontSizeMultiply,
                        color: '#000000',
                        marginTop: '-10px',
                    },
                },
                {
                    id: 'topSearchResult',
                    name: 'topSearchResult',
                    basedOn: 'Normal',
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 20 * fontSizeMultiply,
                        color: '#000000',
                        bold: true,
                        characterSpacing: 8,
                    },
                },
                {
                    id: 'articleLink',
                    name: 'articleLink',
                    run: {
                        font: font,
                        fontFamily: font,
                        size: 18 * fontSizeMultiply,
                        color: '#0000EE',
                        bold: false,
                        characterSpacing: 5,
                        underline: {
                            type: UnderlineType.SINGLE,
                            color: '0000EE',
                        },
                    },
                },
            ],
        };
    }

    public firstPage(gyanSummary: any, pages: any) {
        const today = new Date();
        const formattedDate = today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

        // @ts-expect-error: Suppressing this specific error
        const gyanLogo: any = new ImageRun({
            data: 'data:image/png;base64,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',
            transformation: {
                width: 97,
                height: 33,
            },
        });
        pages.push(
            new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [gyanLogo],
                //text: gyanSummary.gyanTitle,
                spacing: {
                    before: 4000,
                },
            }),
        );
        pages.push(
            new Paragraph({
                text: '',
                spacing: {
                    after: 100,
                },
            }),
        );
        pages.push(
            new Paragraph({
                //text: gyanSummary.gyanTitle.toUpperCase(),
                text: gyanSummary.gyanTitle,
                //heading: HeadingLevel.TITLE,
                alignment: AlignmentType.CENTER,
                style: 'headingMain',
            }),
        );
        pages.push(
            new Paragraph({
                //text: gyanSummary.gyanTitle.toUpperCase(),
                text: formattedDate,
                //heading: HeadingLevel.TITLE,
                alignment: AlignmentType.CENTER,
                style: 'paragraph1',
                spacing: {
                    before: 40,
                },
            }),
        );

        return pages;
    }

    public secondPage(pages: any) {
        pages.push(
            new Paragraph({
                text: 'ABOUT GYAN AI',
                spacing: {
                    after: 200,
                },
                style: 'topicHeadingcp',
                pageBreakBefore: true,
                border: {
                    top: {
                        color: '333333',
                        space: 20,
                        style: BorderStyle.THREE_D_EMBOSS,
                        size: 20,
                    },
                },
            }),
        );
        pages.push(
            new Paragraph({
                text: 'Gyan (pronounced gee-yahn) is an auto-curating AI research platform. It discovers relevant content, automatically identifies major themes and ideas, organizes results into a table of contents and discovers new insights from the web or your content repository in real-time.',
                spacing: {
                    after: 300,
                },
                style: 'paragraphGray1',
            }),
        );
        pages.push(
            new Paragraph({
                text: 'THE VALUE',
                spacing: {
                    after: 300,
                },
                style: 'topicHeadingcp',
            }),
        );
        // pages.push(
        //     new Paragraph({
        //         children: [
        //             new ImageRun({
        //                 data: 'data:image/png;base64,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',
        //                 transformation: {
        //                     width: 80,
        //                     height: 80,
        //                 },
        //                 floating: {
        //                     horizontalPosition: {
        //                         offset: 100000,
        //                         relative: HorizontalPositionRelativeFrom.CHARACTER,
        //                     },
        //                     verticalPosition: {
        //                         offset: 110000,
        //                         relative: VerticalPositionRelativeFrom.PARAGRAPH,
        //                     },
        //                     wrap: {
        //                         type: TextWrappingType.SQUARE,
        //                         side: TextWrappingSide.RIGHT,
        //                     },
        //                 },
        //             }),
        //         ],
        //         border: this.noneBorders,
        //         outlineLevel: 0,
        //     }),
        // );
        pages.push(
            new Paragraph({
                text: 'DISCOVERS RELEVANT CONTENT',
                spacing: {
                    after: 50,
                },
                style: 'aboutHeading2',
            }),
        );
        pages.push(
            new Paragraph({
                text: 'Given a research area, Gyan’s AI casts an expansive search to find the most relevant content. Gyan linguistically analyzes entire articles to determine whether they’re relevant to your research. Gyan extracts relevant insights from each document so that you can be pointed to the most important information quickly.',
                spacing: {
                    after: 500,
                },
                style: 'aboutPointPara',
            }),
        );
        // pages.push(
        //     new Paragraph({
        //         children: [
        //             new ImageRun({
        //                 data: 'data:image/png;base64,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',
        //                 transformation: {
        //                     width: 80,
        //                     height: 80,
        //                 },
        //                 floating: {
        //                     horizontalPosition: {
        //                         offset: 100000,
        //                         relative: HorizontalPositionRelativeFrom.CHARACTER,
        //                         // align: HorizontalPositionAlign.INSIDE
        //                     },
        //                     verticalPosition: {
        //                         offset: 110000,
        //                         relative: VerticalPositionRelativeFrom.PARAGRAPH,
        //                     },
        //                     wrap: {
        //                         type: TextWrappingType.SQUARE,
        //                         side: TextWrappingSide.RIGHT,
        //                     },
        //                 },
        //             }),
        //         ],
        //         border: this.noneBorders,
        //     }),
        // );
        pages.push(
            new Paragraph({
                text: 'ORGANIZES YOUR RESEARCH TO REDUCE TIME',
                spacing: {
                    after: 50,
                },
                style: 'aboutHeading2',
            }),
        );
        pages.push(
            new Paragraph({
                text: 'Gyan saves you time by compiling all relevant content into a table of contents tailored around your research needs. For each topic in your table of contents, Gyan will produce an organized list of relevant articles that discuss that topic, and for each article you will be navigated to the portions of it that are most relevant to your objectives.',
                spacing: {
                    after: 500,
                },
                style: 'aboutPointPara',
            }),
        );
        // pages.push(
        //     new Paragraph({
        //         children: [
        //             new ImageRun({
        //                 data: 'data:image/png;base64,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',
        //                 transformation: {
        //                     width: 80,
        //                     height: 80,
        //                 },
        //                 floating: {
        //                     horizontalPosition: {
        //                         offset: 100000,
        //                         relative: HorizontalPositionRelativeFrom.CHARACTER,
        //                         // align: HorizontalPositionAlign.INSIDE
        //                     },
        //                     verticalPosition: {
        //                         offset: 110000,
        //                         relative: VerticalPositionRelativeFrom.PARAGRAPH,
        //                     },
        //                     wrap: {
        //                         type: TextWrappingType.SQUARE,
        //                         side: TextWrappingSide.RIGHT,
        //                     },
        //                 },
        //             }),
        //         ],
        //         border: this.noneBorders,
        //     }),
        // );
        pages.push(
            new Paragraph({
                text: 'PROVIDES CONTENT SUMMARY',
                spacing: {
                    after: 50,
                },
                style: 'aboutHeading2',
            }),
        );
        pages.push(
            new Paragraph({
                text: 'Gyan provides a brief set of highlights for each selected article, so that you can decide if the article is relevant for your research efforts.',
                spacing: {
                    after: 100,
                },
                style: 'aboutPointPara',
            }),
        );
        return pages;
    }

    public tableOfContents(gyanSummary: any, pages: any) {
        pages.push(
            new Paragraph({
                //text: gyanSummary.gyanTitle,
                text: 'Table of Contents',
                spacing: {
                    after: 400,
                    before: 300,
                },
                style: 'topicHeadingcp',
                pageBreakBefore: true,
            }),
        );
        pages.push(
            new TableOfContents('TABLE OF CONTENTS', {
                hyperlink: true,
                headingStyleRange: '1-5',
            }),
        );
        return pages;
    }

    public researchBriefPage(gyanSummary: any, pages: any) {
        pages.push(
            new Paragraph({
                text: 'RESEARCH BRIEF',
                heading: HeadingLevel.HEADING_2,
                spacing: {
                    after: 200,
                },
                border: {
                    top: {
                        color: '333333',
                        space: 20,
                        style: BorderStyle.THREE_D_EMBOSS,
                        size: 20,
                    },
                },
                pageBreakBefore: true,
            }),
        );
        pages.push(
            new Paragraph({
                text: 'The client tasked Gyan with this key research question:',
                style: 'paragraph1',
                spacing: {
                    after: 200,
                },
            }),
        );
        pages.push(
            new Paragraph({
                text: gyanSummary.gyanTitle,
                // heading: HeadingLevel.HEADING_5,
                style: 'topicText1',
                spacing: {
                    after: 200,
                },
            }),
        );
        pages.push(
            new Paragraph({
                text: 'Based on this question, Gyan suggested the following topics to be a part of this research process:',
                spacing: {
                    after: 200,
                },
                style: 'paragraph1',
            }),
        );
        let topicListBulleted: any = [];
        gyanSummary.topics.map((topic: any) => {
            topicListBulleted = this.topicSummary(topic, 0, topicListBulleted, false);
        });

        pages = pages.concat(topicListBulleted);
        pages.push(
            new Paragraph({
                children: [
                    new TextRun({
                        text: 'Once Gyan did its search, it found ',
                        style: 'paragraph1',
                    }),
                    new TextRun({
                        text: ' ' + gyanSummary.totalSearchArticles + ' total articles.',
                        bold: true,
                    }),
                    new TextRun({
                        text: ' Of those articles, it identified ',
                        style: 'paragraph1',
                    }),
                    new TextRun({
                        text: ' ' + gyanSummary.totalRelevantArticles + ' articles',
                        bold: true,
                    }),
                    new TextRun({
                        text: ' to be the most relevant for the search:',
                        style: 'paragraph1',
                    }),
                ],
                spacing: {
                    after: 200,
                    before: 200,
                },
                style: 'paragraph1',
            }),
        );

        let topicListBulletedWithArticleCount: any = [];
        gyanSummary.topics.map((topic: any) => {
            topicListBulletedWithArticleCount = this.topicSummary(topic, 0, topicListBulletedWithArticleCount, true);
        });
        pages = pages.concat(topicListBulletedWithArticleCount);
        pages.push(
            new Paragraph({
                text: 'The subsequent pages will feature these articles, as well as additional resources that will help the client in their research discovery process.',
                spacing: {
                    before: 200,
                },
                style: 'paragraph1',
            }),
        );

        return pages;
    }

    public topicSummary(topic: any, level: any, arr: any, showcount: any) {
        let indentSpacing = '';
        for (let i = 0; i < level; i++) {
            indentSpacing += '   ';
        }
        arr.push(
            new Paragraph({
                text: showcount ? topic.text + ': ' + topic.relevantArticle + ' articles' : topic.text,
                numbering: {
                    reference: 'my-unique-bullet-points',
                    level: level,
                },
                style: 'paragraphIndented1',
            }),
        );
        if (topic.children) {
            topic.children.map((item: any) => {
                arr = this.topicSummary(item, level + 1, arr, showcount);
            });
        }
        return arr;
    }

    public topicCardHeadingType(level: any) {
        switch (level) {
            case 0:
                return HeadingLevel.HEADING_1;

            case 1:
                return HeadingLevel.HEADING_2;

            case 2:
                return HeadingLevel.HEADING_3;

            case 3:
                return HeadingLevel.HEADING_4;
        }
        return HeadingLevel.HEADING_5;
    }

    public topicCard(topic: any, allTopicArticles: any, topicLevelMultidocSummary: any, arr: any, level: any, breadcrums: any, type: any, topicType: any): any {
        if (type == 'multi') {
            if (topicType !== 'additional') {
                arr.push(
                    new Paragraph({
                        heading: this.topicCardHeadingType(level),
                        pageBreakBefore: true,
                    }),
                    new Paragraph({
                        //text: topic.text.toUpperCase(),
                        text: topic.text,
                        style: 'topicHeading',
                    }),
                );
            }
        } else {
            arr = this.createTopicHeading(arr, topic, allTopicArticles, level, topicType);
        }
        arr = this.topicArticleCard(topic, allTopicArticles, topicLevelMultidocSummary, arr, level, type, topicType);
        if (topic.children) {
            breadcrums[level] = { topicText: topic.text, topicId: topic.id };
            level = level + 1;
            if (type != 'multi') {
                topic.children.map((childTopic: any) => {
                    arr = this.topicCard(childTopic, allTopicArticles, topicLevelMultidocSummary, arr, level, breadcrums, type, topicType);
                });
            }
        }
        return arr;
    }

    public getTopicType(topic: any, allTopicArticles: any, topicType: any) {
        let addTopic = true;
        if (topicType === 'additional') {
            const topicArticles = allTopicArticles.filter((item: any) => {
                return item.topicId == topic.id;
            });
            const articleLength = topicArticles[0]['paragraphs'].length;
            //console.log('articleLength', articleLength);

            addTopic = articleLength > 10 ? true : false;
        }
        return addTopic;
    }

    public createTopicHeading(arr: any, topic: any, allTopicArticles: any, level: any, topicType: any) {
        const addTopic = this.getTopicType(topic, allTopicArticles, topicType);

        const pageBreakBefore = level > 0 ? false : topicType === 'additional' ? false : true;

        if (addTopic) {
            if (topicType === 'additional') {
                arr.push(
                    new Paragraph({
                        text: topic.text,
                        heading: this.topicCardHeadingType(level),
                        pageBreakBefore: pageBreakBefore,
                        //text: topic.text.toUpperCase(),
                        style: 'topicHeading',
                    }),
                );
            } else {
                arr.push(
                    new Paragraph({
                        text: topic.text,
                        heading: this.topicCardHeadingType(level),
                        pageBreakBefore: pageBreakBefore,
                        children: [
                            new Bookmark({
                                id: 'topic_' + topic.id,
                                children: [],
                            }),
                        ],
                    }),
                    new Paragraph({
                        text: topic.text,
                        style: 'topicHeading',
                    }),
                );
            }
        }

        return arr;
    }

    public topicArticleCard(topic: any, allTopicArticles: any, topicLevelMultidocSummary: any, arr: any, level: any, type: any, topicType: any): any {
        const topicArticles = allTopicArticles.filter((item: any) => {
            return item.topicId == topic.id;
        });
        if (type === 'multi') {
            // topicArticles = allTopicArticles;
            // const summary = topicArticles[0].contextualSummary.summary;
            // arr = this.topicMultipleArticleCard(topic, summary, arr, type, level, type);
        } else {
            if (topicArticles.length > 0 && topicArticles[0]['paragraphs'].length > 0) {
                arr = this.topicArticle(topic, topicArticles, topicLevelMultidocSummary, arr, level, topicType);
            } else {
                const topicId = topicArticles[0].topicId;
                const multiArticleTopics = topicLevelMultidocSummary.filter((item: any) => item.topicId == topicId);
                if (multiArticleTopics.length > 0 && topicType !== 'additional') {
                    multiArticleTopics[0]['paragraphs'].map((item: any) => {
                        arr = this.addContextualSummary(item, item.contextualSummary.summary, arr, level);
                    });
                }

                if (topicType !== 'additional' && topic.doSearch) {
                    arr.push(
                        new Paragraph({
                            text: 'No articles found.',
                            style: 'paragraph1',
                        }),
                    );
                    arr.push(
                        new Paragraph({
                            text: '',
                            spacing: {
                                after: 200,
                            },
                        }),
                    );
                }
            }
        }
        return arr;
    }

    public strip_html_tags(str: any) {
        if (str === null || str === '') return false;
        else str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    public topicArticle(topic: any, topicArticles: any, topicLevelMultidocSummary: any, arr: any, level: any, topicType: any): any {
        const topicId = topicArticles[0].topicId;
        const multiArticleTopics = topicLevelMultidocSummary.filter((item: any) => item.topicId == topicId);

        if (multiArticleTopics.length > 0 && topicType !== 'additional') {
            multiArticleTopics[0]['paragraphs'].map((item: any) => {
                arr = this.addContextualSummary(item, item.contextualSummary.summary, arr, level);
            });
        }

        topicArticles[0]['paragraphs'].map((item: any, index: any) => {
            //console.log('topicArticles.topicArticle.length', index);
            if (index <= 9 && topicType !== 'additional') {
                arr = this.addSHeadingArticleCardParent(item, arr, level);
            } else {
                if (topicType === 'additional' && index > 9) {
                    arr = this.addSHeadingArticleCardParent(item, arr, level);
                }
            }
        });

        return arr;
    }

    public addSHeadingArticleCardParent(item: any, arr: any, level: any): any {
        arr = this.addSHeadingArticleCard(item, arr);
        if (item.showSummary && !item.suppressSummary) {
            arr = this.addContextualSummary(item, item.contextualSummary, arr, level);
        } else {
            //arr = this.summaryNotAvaiableArticleCard(arr);
        }
        return arr;
    }

    public addContextualSummary(item: any, summary: any, arr: any, level: any): any {
        const summaryLength = summary.length;
        summary.map((summaryitem: any) => {
            if (summaryitem.summaryText === item.title) {
                //console.log('addContextualSummary.summary.length', summary.length);
            } else {
                arr = this.addSummaryArticleCard(summaryitem, arr);
            }
            if (summaryitem.nextLevel) {
                arr = this.nestedTopicArticleCard(summaryitem, arr, level + 1);
            }
        });
        if (summaryLength <= 0) {
            arr.push(
                new Paragraph({
                    text: '',
                    spacing: {
                        after: 200,
                    },
                }),
            );
        }
        return arr;
    }

    public nestedTopicArticleCard(item: any, arr: any, level: any): any {
        level = level;
        item.children.map((childTopic: any) => {
            if (level > 8) {
                return arr;
            }
            arr.push(
                new Paragraph({
                    text: this.strip_html_tags(childTopic.summaryText.trim()),
                    numbering: {
                        reference: 'my-unique-bullet-points',
                        level: level,
                    },
                    style: 'paragraph1',
                }),
            );
            arr.push(
                new Paragraph({
                    text: '',
                    spacing: {
                        after: 200,
                    },
                }),
            );
            if (childTopic.nextLevel) {
                arr = this.nestedTopicArticleCard(childTopic, arr, level + 1);
            }
        });

        return arr;
    }

    public summaryNotAvaiableArticleCard(arr: any): any {
        arr.push(
            new Paragraph({
                //text: SUMMARYNOTAVAILABLE,
                text: '',
                style: 'paragraph1',
            }),
        );
        arr.push(
            new Paragraph({
                text: '',
                spacing: {
                    after: 200,
                },
            }),
        );

        return arr;
    }

    public addSummaryArticleCard(summaryitem: any, arr: any): any {
        if (summaryitem.summaryText.trim() == 'Summary is not available.' || summaryitem.summaryText.trim() == 'No Summary Available') {
            arr.push(
                new Paragraph({
                    text: '',
                    spacing: {
                        after: 200,
                    },
                }),
            );
            return arr;
        }
        arr.push(
            new Paragraph({
                text: this.strip_html_tags(summaryitem.summaryText.trim()),
                // numbering: {
                //     reference: 'my-unique-bullet-points',
                //     level: 0,
                // },
                style: 'paragraph1',
                alignment: AlignmentType.JUSTIFIED,
            }),
        );
        arr.push(
            new Paragraph({
                text: '',
                spacing: {
                    after: 200,
                },
            }),
        );

        return arr;
    }

    public addSHeadingArticleCard(item: any, arr: any): any {
        const articleTitle = [];
        const articleHead1 = [];
        item.url.indexOf('http') > -1;
        if (item.url.indexOf('http') > -1) {
            articleHead1.push(
                new ExternalHyperlink({
                    children: [
                        new TextRun({
                            text: item.title,
                            style: 'articleLink',
                            bold: false,
                            color: '#0000EE',
                            underline: {
                                type: UnderlineType.SINGLE,
                                color: '0000EE',
                            },
                        }),
                    ],
                    link: item.url,
                }),
            );
        } else {
            articleHead1.push(
                new TextRun({
                    text: item.title,
                    style: 'articleLink',
                    bold: false,
                    color: '#0000EE',
                    underline: {
                        type: UnderlineType.SINGLE,
                        color: '0000EE',
                    },
                }),
            );
        }
        if (item.domain != '') {
            articleHead1.push(
                new TextRun({
                    text: item.domain,
                    italics: true,
                    bold: false,
                    break: 1,
                    style: 'textBold1',
                }),
            );
        }
        if (item.publishedDate != '') {
            articleHead1.push(
                new TextRun({
                    text: item.publishedDate,
                    bold: false,
                    break: 1,
                    style: 'textBold1',
                }),
            );
        }
        arr.push(new Paragraph({ children: articleHead1, style: 'paragraph1', spacing: { after: 20 } }));

        return arr;
    }
}
